const initialState = {
  breakreasonactive: null,
  hasFetchedActive: false,
  isFetchingActive: false,
};

export default function breakworks(state = initialState, action) {
  switch (action.type) {
    case "ADD_BREAK_REASON_ACTIVE":
      return {
        ...state,
        breakreasonactive: action.breakreasonactive,
        hasFetchedActive: true,
        isFetchingActive: false,
      };
    case "REMOVE_BREAK_REASON_ACTIVE":
      return {
        ...state,
        breakreasonactive: null,
      };
    case "SET_FETCHING_BREAK_REASON_ACTIVE":
      return {
        ...state,
        isFetchingActive: action.isFetching,
      };
    case "SET_HAS_FETCHED_BREAK_REASON_ACTIVE":
      return {
        ...state,
        hasFetchedActive: true,
        isFetchingActive: false,
      };
    case "RESET_BREAKWORKS_STATE":
    case "REMOVE_USER": // Limpa o estado quando o usuário faz logout
      return initialState;
    default:
      return state;
  }
}
